export class InvoiceFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getInvoices(filter) {
    return this.instance.get('/v1/invoices', {
      params: filter || null,
    });
  }

  getInvoice(id) {
    return this.instance.get(`/v1/invoices/${id}`);
  }

  checkCnpj(filter) {
    return this.instance.get(`/v1/cad-fornecedores/document`, {
      params: filter || null,
    });
  }

  sendXml(data) {
    const file =
      data?.fileBlob ||
      new File([`${data?.file}`], data?.name || 'invoice.xml', {
        type: 'application/xml',
      });
    const formData = new FormData();
    formData.append('file', file);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.instance.patch(`/v1/invoices/uploads`, formData, config);
  }

  sendPdf(data) {
    const file =
      data?.fileBlob ||
      new File([`${data?.file || ''}`], data?.name || 'invoice.pdf', {
        type: 'application/pdf',
      });
    const formData = new FormData();
    formData.append('file', file);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.instance.patch(`/v1/invoices/uploads`, formData, config);
  }

  extractPdfInvoice(fileData) {
    const formData = new FormData();
    formData.append('file', fileData);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 180000,
    };
    return this.instance.post(
      `/v1/invoices/uploads/extract-pdf`,
      formData,
      config,
    );
  }

  insertInvoice(data) {
    return this.instance.post(`/v1/invoices`, data);
  }

  updateInvoice(id, data) {
    return this.instance.put(`/v1/invoices/${id}`, data);
  }

  deleteInvoice(id) {
    return this.instance.delete(`/v1/invoices/${id}`);
  }

  getInvoiceService(id, filter) {
    return this.instance.get(`/v1/invoices/${id}/items`, {
      params: filter || null,
    });
  }

  deleteInvoiceService(id, idService) {
    return this.instance.delete(`/v1/invoices/${id}/items/${idService}`);
  }

  linkServiceFinancial(id, data) {
    return this.instance.post(`/v1/invoices/${id}/financial`, data);
  }

  linkServiceStock(id, data) {
    return this.instance.post(`/v1/invoices/${id}/stock`, data);
  }

  getLancamento(id) {
    return this.instance.get(`/v1/invoices/${id}/lancamento`, {
      timeout: 120000,
    });
  }

  getArquivos(id) {
    return this.instance.get(`/v1/invoices/${id}/arquivos`);
  }

  vincularArquivo(id, data) {
    return this.instance.post(`/v1/invoices/${id}/arquivos`, data);
  }

  removerArquivo(id, fileId) {
    return this.instance.delete(`/v1/invoices/${id}/arquivos/${fileId}`);
  }

  desvincularConta(id, financeiroId) {
    return this.instance.delete(`/v1/invoices/${id}/contas/${financeiroId}`);
  }

  lancarInvoice(id, data) {
    return this.instance.post(`/v1/invoices/${id}/lancar`, data, {
      timeout: 120000,
    });
  }
}

export default InvoiceFactory;
